'use client'

import ContactBanner from '@/components/ContactBanner'
import { useDictionary } from '@/contexts/DictionaryContext'
import { Award, BarChart3, Shield, Zap } from 'lucide-react'
import { useRef } from 'react'
import { BlogSummarySection } from '../../components/BlogSummarySection'
import { CertificationsSection } from '../../components/CertificationsSection'
import { ClientLogosSection } from '../../components/ClientLogosSection'
import { HomeHeroSection } from '../../components/HomeHeroSection'
import { HomeValuesSection } from '../../components/HomeValuesSection'
import { ServicesSection } from '../../components/ServicesSection'
import { blogPosts } from './blog/lib/posts'

export default function Home() {
  const { dictionary, locale } = useDictionary() // Corrected: use locale
  const containerRef = useRef(null)

  // Define the values array using translations
  const values = [
    {
      icon: <Zap className='h-6 w-6 text-blue-600' />,
      title: dictionary.home.values.items[0].title,
      description: dictionary.home.values.items[0].description,
    },
    {
      icon: <Shield className='h-6 w-6 text-blue-600' />,
      title: dictionary.home.values.items[1].title,
      description: dictionary.home.values.items[1].description,
    },
    {
      icon: <BarChart3 className='h-6 w-6 text-blue-600' />,
      title: dictionary.home.values.items[2].title,
      description: dictionary.home.values.items[2].description,
    },
    {
      icon: <Award className='h-6 w-6 text-blue-600' />,
      title: dictionary.home.values.items[3].title,
      description: dictionary.home.values.items[3].description,
    },
  ]

  return (
    <>
      <HomeHeroSection />
      <section
        className='flex flex-col'
        ref={containerRef}
      >
        {/* Client Logos Section */}
        <ClientLogosSection dictionary={dictionary.home.partners} />

        {/* Values Section */}
        <HomeValuesSection
          dictionary={dictionary.home.values}
          values={values}
        />

        {/* Certifications Section */}
        <CertificationsSection dictionary={dictionary.home.certifications} />

        {/* Services Section */}
        <ServicesSection />
        {/* Blog Summary Section */}
        <BlogSummarySection
          blogPosts={blogPosts}
          lang={locale} // Corrected: use locale
        />
        <ContactBanner />
      </section>
    </>
  )
}
